import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { InfoTable, InfoTableAddRow } from "@myplay/ui";

import CoachTeamsTableItem from './CoachTeamsTableItem';
import { CATEGORY, HIGHLIGHTS_COUNT, NAME, YEAR, PLAYERS_COUNT, VIDEOS_COUNT, TEAMS_ROUTE } from '../../utils/constants';
import I18N from '../../I18N';
import sort from '../../utils/sort';
import history from '../../utils/history';
import './CoachTeamsTable.scss';

const headers = ["Team", "Sport", "Season", "Members", "Videos", "Total HL", ""];

const CoachTeamsTable = ({ teams, onRemoveCoachFromTeam, onAssignTeam }) => {
  const [sortedTeams, setSortedTeams] = useState(teams);
  const [isDesc, setIsDesc] = useState(false);
  const [sortedBy, setSortedBy] = useState("");
  
  const handleHeaderClick = header => {
    let sorted = [];
    switch (header) {
      case "Team":
        sorted = [...sort(sortedTeams, NAME)];
        break;
      case "Sport":
        sorted = [...sort(sortedTeams, CATEGORY)];
        break;
      case "Season":
        sorted = [...sort(sortedTeams, YEAR)];
        break;
      case "Members":
        sorted = [...sort(sortedTeams, PLAYERS_COUNT)];
        break;
      case "Total HL":
        sorted = [...sort(sortedTeams, HIGHLIGHTS_COUNT)];
        break;
      case "Videos":
        sorted = [...sort(sortedTeams, VIDEOS_COUNT)];
        break;
    }

    if (isDesc) {
      sorted.reverse();
    };
    setIsDesc(!isDesc);
    setSortedTeams([...sorted]);
    setSortedBy(header);
  }

  const handleTeamClick = ({ team }) => {
    history.push(`${TEAMS_ROUTE}/?teamId=${team._id}`);
  };

  const handleRemoveCoachFromTeam = (event, team) => {
    event.stopPropagation();
    onRemoveCoachFromTeam(team);
  }

  return (
    <div className="coach-teams-table" data-testid="coach-teams-table">
      <InfoTable
        headers={headers}
        gridTemplateColumns="20% 12% 12% 12% 12% 12% auto"
        onHeaderClick={handleHeaderClick}
        sortedBy={sortedBy}
        isDesc={isDesc}
        onChildClick={handleTeamClick}
      >
        {sortedTeams.map(team => 
          <CoachTeamsTableItem 
            team={team} 
            onRemoveCoachFromTeam={event => handleRemoveCoachFromTeam(event, team)}
          />
        )}
      </InfoTable>
      <InfoTableAddRow 
        text={I18N.t("ASSIGN_TEAM").toUpperCase()}
        onClick={onAssignTeam}
      />
    </div>
  );
};

CoachTeamsTable.propTypes = {
  teams: PropTypes.array, 
  onRemoveCoachFromTeam: PropTypes.func, 
  onAssignTeam: PropTypes.func
};

CoachTeamsTable.defaultProps = {
  teams: [], 
  onRemoveCoachFromTeam: ()=> {}, 
  onAssignTeam: ()=> {}
};


export default observer(CoachTeamsTable);